import type { DocStatus } from "../lib/publicDocs";
import { StatusBanner, type StatusBannerVariant } from "./StatusBanner";

const BANNER: Record<Exclude<DocStatus, "ga">, { variant: StatusBannerVariant; text: string }> = {
	pilot: {
		variant: "pilot",
		text: "Staging pilot — contact us for access.",
	},
	preview: {
		variant: "preview",
		text: "Coming soon — preview documentation.",
	},
	draft: {
		variant: "draft",
		text: "Draft — requires legal review. Not final for procurement.",
	},
};

export function DocStatusBanner({ status }: { status: DocStatus }) {
	if (status === "ga") return null;
	const banner = BANNER[status];
	return <StatusBanner variant={banner.variant}>{banner.text}</StatusBanner>;
}
